export default {
	themes: {
		light: 'Claro',
		dark: 'Oscuro'
	}
};
